<style>
    .tooltip {
      position: relative;
      display: inline-block;
      border-bottom: 1px dotted black;
    }
    
    .tooltip .tooltiptext {
      visibility: hidden;
      width: 120px;
      background-color: black;
      color: #fff;
      text-align: center;
      border-radius: 6px;
      padding: 5px 0;
    
      /* Position the tooltip */
      position: absolute;
      z-index: 1;
    }
    
    .tooltip:hover .tooltiptext {
      visibility: visible;
    }
</style>
<div class="modal-header">
<button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
</button>
<h4 class="modal-title text-danger" id="modal-basic-title">{{ModalHeader}} </h4>
</div>
<div class="modal-body" >
<table class="table table-bordered">
    <thead>
        <tr>
            <th scope="col">Sppplier AB#</th>
            <th scope="col">Object Account</th>
            <th scope="col" >Current Month Amt</th>
            <th scope="col" >Previous Month Amt</th>
            <th scope="col">Comment</th>
        </tr>
    </thead>
    <tbody>
            <tr *ngFor ="let cmt of vowdCommentList">
                    <td>{{cmt.supplierab}}</td>
                    <td>{{cmt.objectaccount}}</td>
                    <td>{{cmt.CurAmt| currency}}</td>
                    <td>{{cmt.PrevAmt| currency}}</td>
                    <td>
                            <div class="tooltip"> 
                                <textarea [(ngModel)]="cmt.Comment" (ngModelChange)="checkComment()" ></textarea>
                                    <span class="tooltiptext">Please insert reason for vaiance here</span>
                            </div>
                    </td>
            </tr>
    </tbody>
</table>
</div>
<div class="modal-footer"  style="text-align: center;">
 <button class="btn btn-primary " [disabled]="IsCommentNullorEmpty" (click)="submit()">Submit</button> &nbsp;
<button type="button" class="btn btn-primary" (click)="closeModal()">
  <span class="glyphicon glyphicon-remove"></span>
    Close
</button>
</div>

